import React, { Component } from "react";
import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import Form from "./Form";
import { toast } from "../../../utils/helpers";

class CreateSolicitud extends Component {
    state = {
        vehiculos: [],
        empleados: [],
        saving: false
    };
    componentDidMount() {
        this.getTable("vehiculos");
        this.getTable("empleados", "?estado=activos");
    }
    createSolicitud = async event => {
        event.preventDefault();

        this.setState({
            saving: true
        });

        const token = auth.getToken();
        const data = new FormData(event.target);

        const url = `solicitudes`;

        const res = await fetch(apiUrl(url), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token
            }
        });

        const response = await res.json();

        if (response.success) {
            if (this.props.getSolicitudes) {
                this.props.getSolicitudes();
            }
            document.getElementById("solicitudesform").reset();
            this.props.toggle();

            toast("Solicitud creada exitosamente.");
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }

        this.setState({
            saving: false
        });
    };
    getTable = async (url = null, params = "") => {
        const table = await this.props.request(url + params);

        if (table.data && table.data.length > 0) {
            this.setState({
                [url]: table.data
            });
        }
    };
    render() {
        const { empleado } = this.props;
        const { vehiculos, empleados } = this.state;
        return (
            <form
                id='solicitudesform'
                method='post'
                onSubmit={this.createSolicitud}>
                <input type='hidden' name='_method' value='post' />
                <div className='popup__header'>Nueva Solicitud</div>
                <Form
                    empleado={empleado}
                    vehiculos={vehiculos}
                    empleados={empleados}
                />
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={this.props.toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    {this.state.saving ? (
                        <Loader type='small' />
                    ) : (
                        <button type='submit' className='btn btn-primary'>
                            Crear
                        </button>
                    )}
                </div>
            </form>
        );
    }
}

export default withRequest(CreateSolicitud);
